<template>
  <div class="vx-row">
    <div class="w-full vx-col">
        <vx-card  titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters" :collapse-action="true">
            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                    <label class="text-sm opacity-100 text-bold">Code</label>
                    <vs-input type="search"  placeholder="Search.." v-model="filters['code']" class="w-full mb-4 md:mb-0"/>
                </div>
                <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                    <label class="text-sm opacity-100 text-bold">Name</label>
                    <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0"/>
                </div>
            </div>
            <div class="mt-5 vx-row">
                <div class="w-full ml-auto vx-col">
                    <vs-button class="float-right mr-4" size="small"
                                color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
                </div>
            </div>
        </vx-card>
      <vx-card :title="'INCOTERMS'" class="">
        <template slot="actions">
          <vs-button v-can="'edit-incoterms-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="incoterms-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="incoterms">
              <template slot="thead">
                <vs-th sort-key="code" width="15%">Code</vs-th>
                <vs-th width="20%">Name</vs-th>
                <vs-th width="30%">Description</vs-th>
                <vs-th width="10%">Is shipping included?</vs-th>
                <vs-th width="5%">Default</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                   <vs-td :data="data[indextr].description">
                    {{ data[indextr].description }}
                  </vs-td>

                  <vs-td :class="data[indextr].is_price_included ? 'text-primary font-bold' : 'text-danger font-bold'">
                    {{ data[indextr].is_price_included ? 'YES' : 'NO' }}
                  </vs-td>

                  <vs-td>
                    <vs-switch v-model="data[indextr].is_default" icon-pack="feather" vs-icon-on="icon-check-circle"
                              vs-icon-off="icon-slash" class="mt-3 w-8" @input="updateDefaultIncoterm(data[indextr])">
                      <span slot="on"></span>
                      <span slot="off"></span>
                    </vs-switch>
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row" v-can="'edit-incoterms-setting'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <add-new-incoterms-pop-up ref="AddNewIncotermsPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import AddNewIncotermsPopUp from "@/components/popups/settings/incoterms/AddNewIncotermsPopUp";

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import {defaultPagination, perPageList} from "../../../../constants/config";

  const IncotermRepository = RepositoryFactory.get('incoterm');
  export default {
    name: "IncotermSettings",
    data() {
      return {
        incoterms: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      AddNewIncotermsPopUp
    },
    methods: {
      async refreshData() {
        await this.fetchIncoterms()
      },
      async fetchIncoterms() {
        await this.$vs.loading({
          container: '#incoterms-table',
          scale: 0.45
        })
        const {data} = await IncotermRepository.getListOfIncoterms(this.page, this.filterQuery, this.perPage, this.sort)
        this.incoterms =  data.data
         this.meta = data.meta
        this.$vs.loading.close('#incoterms-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.AddNewIncotermsPopUp.openPopup()
      },
      async onClickUpdate(id) {
        await this.$refs.AddNewIncotermsPopUp.openPopup(id)
      },
      openConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to delete this ?',
          accept: this.onClickDelete,
          parameters: [id]
        })
      },
      async onClickDelete(params) {
        try {
          await IncotermRepository.deleteIncoterms(params[0])
          await this.fetchIncoterms()
          await this.showSuccessMessage('Incoterm Deleted!');
        }catch (e) {
            this.convertAndNotifyError(e)
        }
      },
      filterQueryUpdate (){
        this.fetchIncoterms()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchIncoterms()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchIncoterms()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      async updateDefaultIncoterm(data) {
        try {
          await IncotermRepository.updateIncoterms(data.id, data);
          await this.fetchIncoterms()
        } catch (error) {
          this.convertAndNotifyError(error)
        }
      }
    },
    async mounted() {
      await this.fetchIncoterms()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchIncoterms()
      },
      perPage() {
        this.fetchIncoterms()
      }
    }
  }
</script>

<style scoped>

</style>
